import { useMutation, useQueryClient } from '@tanstack/react-query'
import axios, { type AxiosResponse } from 'axios'
import type { StoresGroup } from '../../models/stores-group'
import { toast } from 'react-toastify'
import { QUERY_KEY } from './useApiGetStoresGroup'
import { useTranslation } from 'react-i18next'

export const useApiDeleteStoresGroup = () => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  return useMutation<AxiosResponse, Error, StoresGroup>({
    mutationFn: (storesGroup: StoresGroup) => {
      return axios.delete(`/stores_groups/${storesGroup.id}`)
    },

    onError: (error: Error) => {
      toast.error(t(error?.message || 'error.global.message'))
    },

    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [QUERY_KEY] })
    }
  })
}

export const useApiDeleteSharedStoresGroup = () => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  return useMutation<AxiosResponse, Error, StoresGroup>({
    mutationFn: (storeGroup: StoresGroup) => {
      return axios.delete(`/stores_groups/shared/${storeGroup.id}`)
    },

    onError: (error: Error) => {
      toast.error(t(error?.message || 'error.global.message'))
    },

    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [QUERY_KEY] })
    }
  })
}
